import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-[#EDE7DF] border-t border-[#D4C9BE] mt-auto">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <Link to="/" className="inline-block mb-3 cursor-pointer">
              <span
                className="text-sm font-bold text-[#2C2416] hover:text-[#5B7B6F] transition-colors"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                つくってなんぼ
              </span>
            </Link>
            <p
              className="text-xs text-[#7A6E62] leading-relaxed mb-4"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              AIを使って作る・整える・速くする過程を、再現できる形で届ける実践メディア。
            </p>
            <div className="flex items-center gap-2">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full border border-[#C8BFB5] text-[#7A6E62] hover:border-[#2C2416] hover:text-[#2C2416] transition-all cursor-pointer"
                aria-label="X (Twitter)"
              >
                <i className="ri-twitter-x-line text-xs"></i>
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full border border-[#C8BFB5] text-[#7A6E62] hover:border-[#2C2416] hover:text-[#2C2416] transition-all cursor-pointer"
                aria-label="GitHub"
              >
                <i className="ri-github-line text-xs"></i>
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h3
              className="text-xs font-bold text-[#2C2416] uppercase tracking-widest mb-4"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              カテゴリ
            </h3>
            <ul className="space-y-2.5">
              {[
                { label: 'AIツール活用', href: '/categories/ai-creation' },
                { label: '制作フロー', href: '/categories/build-log' },
                { label: 'UI再現', href: '/categories/ai-creation' },
                { label: '比較検証', href: '/categories/productivity' },
                { label: 'プロンプト・仕様書', href: '/categories/productivity' },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-xs text-[#7A6E62] hover:text-[#2C2416] transition-colors cursor-pointer"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Series */}
          <div>
            <h3
              className="text-xs font-bold text-[#2C2416] uppercase tracking-widest mb-4"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              シリーズ
            </h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Spotify風UI再現', href: '/categories/ai-creation' },
                { label: 'AI記事制作フロー', href: '/categories/build-log' },
                { label: 'サイト制作記録', href: '/categories/build-log' },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-xs text-[#7A6E62] hover:text-[#2C2416] transition-colors cursor-pointer"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Site */}
          <div>
            <h3
              className="text-xs font-bold text-[#2C2416] uppercase tracking-widest mb-4"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              サイト
            </h3>
            <ul className="space-y-2.5">
              {[
                { label: 'About', href: '/about' },
                { label: 'お問い合わせ', href: '/contact' },
                { label: 'プライバシーポリシー', href: '/legal/privacy' },
                { label: '利用規約', href: '/legal/terms' },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-xs text-[#7A6E62] hover:text-[#2C2416] transition-colors cursor-pointer"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-[#C8BFB5] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p
            className="text-xs text-[#9A8E84]"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            © 2026 つくってなんぼ. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-[#9A8E84] hover:text-[#5B7B6F] transition-colors cursor-pointer whitespace-nowrap"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
